<template>
	<el-drawer size="50%" title="快捷话术设置" :visible.sync="drawer" :modal-append-to-body="false" direction="rtl" :wrapperClosable="false">
		<section class="fastwords-add-edit">
			<el-form ref="form" :model="form" :rules="formRules" label-width="100px">
				<el-form-item label="文件类型：" prop="treeType">
					<el-radio-group v-model="form.treeType" :disabled="isDisabled">
					    <el-radio label="folder">文件夹</el-radio>
					    <el-radio label="file">文件</el-radio>
					 </el-radio-group>
				</el-form-item>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="创建人：" prop="createBy">
							<el-input placeholder="请输入创建人" v-model="form.createBy" clearable disabled>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="创建时间：" prop="createTime">
							<el-date-picker disabled  v-model="form.createTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" clearable></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="是否CSR可见：" prop="visibility">
					<el-radio-group v-model="form.visibility">
					    <el-radio :label="true">可见</el-radio>
					    <el-radio :label="false">不可见</el-radio>
					 </el-radio-group>
				</el-form-item>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="标题：" prop="name">
							<el-input placeholder="请输入标题" v-model="form.name" clearable>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.treeType == 'file'">
						<el-form-item label="文件类型：" prop="type">
							<el-select v-model="form.type" clearable placeholder="请选择">
							    <el-option v-for="item in options_type"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							  </el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20" v-if="form.type == 'miniprogrampage'">
					<el-col :span="12">
						<el-form-item label="卡片路径：" prop="pagepath">
							<el-input placeholder="请输入卡片路径" v-model="form.pagepath" clearable>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="appID：" prop="appid">
							<el-input placeholder="请输入appid" v-model="form.appid" clearable>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20" v-if="form.type == 'news'">
					<el-col :span="12">
						<el-form-item label="新闻链接：" prop="newsurl">
							<el-input placeholder="请输入新闻链接" v-model="form.newsurl" clearable>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item :label="form.type == 'video' ? '视频' : '封面/图片'" prop="image" v-if="form.type && form.type !='text'">
					<el-upload
					  class="avatar-uploader"
					  action=""
					  :show-file-list="false"
					  :http-request="uploadFileEvent"
					  :accept="form.type == 'video'? videoAccepts : imgAccepts">
					  <div v-if="form.image" class="avatar">
						   <video v-if="form.type == 'video'" :src="form.image" class="avatar" controls></video>
						   <img v-else :src="form.image" alt="暂无图片">
					  </div>
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item :label="getLable() + '：'" prop="content" v-if="getLable()">
					<el-input type="textarea" :placeholder="'请输入'+ getLable()" v-model="form.content" maxlength="300"
					  show-word-limit resize="none" clearable></el-input>
				</el-form-item>
				
			</el-form>
			<div class="demo-drawer__footer">
					<el-button @click="drawer = false" size="mini">取 消</el-button>
					<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
					</el-button>
			 </div>
		</section>
	</el-drawer>
</template>

<script>
	export default {
		data(){
			return {
				isDisabled:true,//是否可选择文件类型
				loading:false,
				drawer:false,
				imageRule:['image/png', 'image/jpeg','image/jpg','image/bmp'],
				imgAccepts:'.jpg,.jpeg,.bmp,.png',
				videoAccepts:'.mp4',
				videoRule:['video/mp4'],
				form:{
					treeType:'folder',
					name:'',
					visibility:true,
					createBy:this.$store.state.user.name,
					createTime:'',
					type:'',
					pagepath:'',
					appid:'',
					newsurl:'',
					image:'',
					content:'',
					id:'',
					pid:''
					
				},
				formRules:{
					name:[{ required: true, message: '请输入标题', trigger: 'blur' }],
					type:[{ required: true, message: '请选择类型', trigger: 'change' }],
					content:[{ required: true, message: '内容不能为空', trigger: 'blur' }],
					image:[{ required: true, message: '请上传图片', trigger: 'change' }],
					pagepath:[{ required: true, message: '路径不能为空', trigger: 'blur' }],
					appid:[{ required: true, message: '内容不能为空', trigger: 'blur' }],
					newsurl:[{ required: true, message: '内容不能为空', trigger: 'blur' }],
				},
				options_type:[
					{label:'文本',value:'text'},
					{label:'图片',value:'image'},
					{label:'视频',value:'video'},
					{label:'卡片',value:'miniprogrampage'},
					{label:'图文',value:'news'},
				],
				cuurrent_file:'',
				// uploadPath:process.env.VUE_APP_BASE_URL,
				
			}
		},
		methods:{
			onSave(){
				let params = {
					name:this.form.name,
					pid:this.form.pid,
					id:this.form.id,
					treeType:this.form.treeType,
					createTime:this.form.createTime,
					createBy:this.$store.state.user.agentId,
					visibility:this.form.visibility,
					type:this.form.treeType == 'folder' ? '' : this.form.type,
					content:this.form.content,
				}
				if(this.form.type == 'video' || this.form.type == 'image'){
					params.attachment = {
						fileurl:this.form.image,
						filename:this.cuurrent_file.filename,
						filetype:this.cuurrent_file.filetype,
						filesize:this.cuurrent_file.filesize,
						id:this.cuurrent_file.id,
					}
				}
				if(this.form.type == 'miniprogrampage'){
					params.miniProgram = {
						pagepath: this.form.pagepath ,
						appid:this.form.appid ,
						thumbMediaId:this.form.image,
						title:this.form.name
					}
				}
				if(this.form.type == 'news'){
					params.attachment = {
						newsurl: this.form.newsurl,
						fileurl:this.form.image,
						filename:this.cuurrent_file.filename,
						filetype:this.cuurrent_file.filetype,
						filesize:this.cuurrent_file.filesize,
						id:this.cuurrent_file.id,
					}
				}
				this.$refs['form'].validate((valid) => {
				  if (valid) {
					   this.loading = true
					   this.$api.updateSystemFastWordsListItem(params).then(res => {
							this.loading = false
							if(res.errcode == 0){
								this.$message.success(`${this.form.id ? '编辑':'添加'}成功`)
								this.drawer = false
								this.$emit('updateData',{
									nodes:this.nodes,
									id:this.form.id,
								})
							}
						}).catch(err => {
							this.loading = false
						})
				   } 
				});
			},
			onEdit(node){
				this.isDisabled = false
				this.drawer = true
				this.$nextTick(()=>{
					this.$refs.form.resetFields()
					this.nodes = node
					this.form.name = node.data.name
					this.form.treeType = node.data.treeType
					this.form.visibility = node.data.visibility
					this.form.createBy = node.data.createBy || this.$store.state.user.name
					this.form.type = node.data.type
					this.form.content = node.data.content
					this.form.id = node.data.id
					this.form.pid = node.data.pid
					this.form.createTime = node.data.createTime || new Date().getTime()
					if(node.data.miniProgram){
						this.form.pagepath = node.data.miniProgram.pagepath
						this.form.appid = node.data.miniProgram.appid
						this.form.image = node.data.miniProgram.thumbMediaId
						this.form.name = node.data.miniProgram.title
					}
					if(node.data.attachment){
						this.form.image = node.data.attachment.fileurl
						this.form.newsurl = node.data.attachment.newsurl
					}
					
				})
			},
			
			onAdd(node){
				this.drawer = true
				this.isDisabled = false
				this.$nextTick(()=>{
					let keys = Object.keys(this.form);
					keys.map(key => {
						this.form[key] = ''
					})
					this.form.treeType = 'folder'
					this.form.visibility = true
					this.form.createBy = this.$store.state.user.name
					this.form.pid = node.data.id
					this.nodes = node
					this.form.createTime = new Date().getTime()
				})
			},
			getLable(){
				let label = ''
				switch(this.form.type){
					case 'text':
						label = '文本'
						break;
					case 'news':
						label = '新闻内容'
						break;
					default:
					label = ''
				}
				return label
			},
			beforeUpload(file){
				let uploadType = this.form.type == 'video' ? this.videoRule:this.imageRule
				const isTrue = uploadType.includes(file.type);
				const isLimitSize = file.size / 1024 / 1024 < 20;
				if(!isTrue) {
					this.$message.error(`上传只能是${uploadType.join(',')}格式`)
					return false
				}
				if(!isLimitSize) {
					this.$message.error("上传文件大小不能超过20M")
					return false
				}
				return true
			},
			uploadFileEvent(params){
				if(this.beforeUpload(params.file)) {
					const formData = new FormData()
					 formData.append('file', params.file)
					 this.$api.uploadSystemFastWordsFile(formData).then(res => {
						if(res.errcode == 0) {
							this.form.image = res.data.fileurl
							this.cuurrent_file = res.data
						}		  
					 })
				}
			}
		}
	}
</script>

<style lang="scss">
	.fastwords-add-edit {
		padding: 0 40px;
		.avatar-uploader .el-upload {
		   border: 1px dashed #d9d9d9;
		   border-radius: 6px;
		   cursor: pointer;
		   position: relative;
		   overflow: hidden;
		 }
		  .avatar-uploader .el-upload:hover {
		     border-color: #409EFF;
		   }
		   .avatar-uploader-icon {
		     font-size: 28px;
		     color: #8c939d;
		     width: 178px;
		     height: 178px;
		     line-height: 178px;
		     text-align: center;
		   }
		   .avatar {
		     width: 178px;
		     height: 178px;
		     display: block;
			 img {
			 	width: 178px;		   
			 }
		   }
		  
	}
</style>
